import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "date", "rentalSelect", "durationContainer", "startTimeSelect", "startTimeWrapper", "quantityInput",
    "mobile", "enteredByWrapper"
  ]
  static values = { companySlug: String }

  connect() {
    const rentalId = this.hasRentalSelectTarget ? this.rentalSelectTarget.value : null
    const date = this.hasDateTarget ? this.dateTarget.value : null
    if (rentalId) {
      this.updateDirectBookingRequirements()
    }
    if (rentalId && date) {
      this.loadSchedule()
    }
  }

  dateChanged() {
    this.loadSchedule()
  }

  rentalChanged() {
    this.clearStartTimes()
    this.updateDirectBookingRequirements()
    this.loadSchedule()
  }

  updateDirectBookingRequirements() {
    const selected = this.rentalSelectTarget.selectedOptions[0]
    if (!selected) return

    const requiresPhone = selected.dataset.requiresPhone === "true"
    const requiresEnteredBy = selected.dataset.requiresEnteredBy === "true"

    if (this.hasMobileTarget) {
      this.mobileTarget.required = requiresPhone
    }

    if (this.hasEnteredByWrapperTarget) {
      const input = this.enteredByWrapperTarget.querySelector("input")
      if (input) input.required = requiresEnteredBy
      this.enteredByWrapperTarget.classList.toggle("d-none", !requiresEnteredBy)
    }
  }

  async loadSchedule() {
    const rentalId = this.rentalSelectTarget.value
    const date = this.dateTarget.value
    if (!rentalId || !date) return

    try {
      const url = `/companies/rental_schedule_info/times_for_rental?rental_id=${rentalId}&date=${date}`
      const response = await fetch(url, { headers: { Accept: "application/json" } })
      const data = await response.json()

      if (data.available) {
        this.renderDurations(data.durations || [])
        this.populateStartTimes(data.start_times || [])
      } else {
        this.renderDurations([])
        this.clearStartTimes()
      }
    } catch (e) {
      console.error("Failed to load rental schedule", e)
    }
  }

  renderDurations(durations) {
    if (!this.hasDurationContainerTarget) return

    const container = this.durationContainerTarget

    if (durations.length === 0) {
      container.innerHTML = '<div class="text-muted small">No schedule found for this date.</div>'
      return
    }

    const currentVal = container.querySelector("input[type='radio']:checked")?.value

    const wrapper = document.createElement("div")
    wrapper.className = "d-flex flex-wrap gap-2"

    durations.forEach((duration, index) => {
      const isChecked = currentVal ? String(currentVal) === String(duration.id) : index === 0
      const div = document.createElement("div")
      div.className = "form-check"
      div.dataset.durationId = duration.id
      div.innerHTML = `
        <input class="form-check-input" type="radio"
               name="rental_reservation[rental_duration_id]"
               value="${duration.id}"
               id="duration_${duration.id}"
               ${isChecked ? "checked" : ""}
               required>
        <label class="form-check-label" for="duration_${duration.id}">
          ${duration.label}
        </label>
      `
      wrapper.appendChild(div)
    })

    container.innerHTML = ""
    container.appendChild(wrapper)
  }

  populateStartTimes(slots) {
    const sel = this.startTimeSelectTarget
    const currentVal = sel.value
    sel.innerHTML = '<option value="">Select start time...</option>'
    slots.forEach(({ label, value }) => {
      const opt = document.createElement("option")
      opt.value = value
      opt.textContent = label
      if (String(value) === String(currentVal)) opt.selected = true
      sel.appendChild(opt)
    })
    if (this.hasStartTimeWrapperTarget) {
      this.startTimeWrapperTarget.classList.toggle("d-none", slots.length === 0)
    }
  }

  clearStartTimes() {
    if (!this.hasStartTimeSelectTarget) return
    this.startTimeSelectTarget.innerHTML = '<option value="">Select start time...</option>'
  }

  startTimeChanged() {
    if (!this.hasQuantityInputTarget) return
    const slotValue = this.startTimeSelectTarget.value
    this.quantityInputTarget.disabled = !slotValue
  }
}
